const NS = 'SiteHeroWidget';
const CLS = 'siteHeroWidget';

export class SiteHeroWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$inner = this.$element.find(`.${CLS}-inner`);
		this.$buttonClose = this.$element.find(`.${CLS}-close`);
		this.$buttonHeroCTA = this.$element.find(`.${CLS}-hero-cta`);

		this.toggleAnimationDuration = 400;

		this.assignDataClosedAttribute();
		this.$inner.height(this.$element.height());

		this.$buttonClose.on('click', () => {
			this.closeSiteHeroWidget();
		});

		this.$buttonHeroCTA.on('click', () => {
			this.closeSiteHeroWidget();
		});

		$(window).resize(_.debounce(() => {
			this.$inner.height('unset');
			this.$element.height('unset');
			this.$inner.height(this.$element.height());
			if(this.$element.attr('data-closed') === 'true') {
				this.$element.height(0);
			}
		}, 50));
	}

	assignDataClosedAttribute() {
		if((localStorage.getItem(`${CLS}.closed`) === 'true')) {
			this.$element.attr('data-closed', true); // Displays the siteHero widget
		}
		else {
			this.$element.attr('data-closed', false);
		}
	}

	closeSiteHeroWidget() {
		this.$element.animate({ height: 0 }, this.toggleAnimationDuration, 'swing', () => {
			localStorage.setItem(`${CLS}.closed`, true);
			this.$element.attr('data-closed', true);
		});
	}
}
